import { render, staticRenderFns } from "./IpHistory.vue?vue&type=template&id=3f62d0cc&scoped=true&"
import script from "./IpHistory.vue?vue&type=script&lang=js&"
export * from "./IpHistory.vue?vue&type=script&lang=js&"
import style0 from "./IpHistory.vue?vue&type=style&index=0&id=3f62d0cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62d0cc",
  null
  
)

export default component.exports